import { render, staticRenderFns } from "./FormRestaurante.vue?vue&type=template&id=4ec55516&scoped=true"
import script from "./FormRestaurante.vue?vue&type=script&lang=js"
export * from "./FormRestaurante.vue?vue&type=script&lang=js"
import style0 from "./FormRestaurante.vue?vue&type=style&index=0&id=4ec55516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec55516",
  null
  
)

export default component.exports